import { takeLatest, call, put } from 'redux-saga/effects'
import * as constants from 'store/constants'
import api from './api'

function* getDebtNotice({ payload }) {
  try {
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: true })
    const res = yield call(api.getDebtNotice, payload?.identifier)
    const list = res?.applications?.debtNotice?.debtNoticeListData
    yield put({ type: constants.DEBT_NOTICE_DATA, payload: list })
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: false })
  } catch (e) {
    yield put({ type: constants.DEBT_NOTICE_ERROR, payload: e.message || e })
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: false })
  }
}

function* getDebtNoticeFinancialResponsible({ payload }) {
  try {
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: true })
    const res = yield call(api.getDebtNoticeFinancialResponsible, payload?.identifier)
    const list = res?.applications?.debtNotice?.debtNoticeFinancialResponsibleListData
    yield put({ type: constants.DEBT_NOTICE_DATA, payload: list })
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: false })
  } catch (e) {
    yield put({ type: constants.DEBT_NOTICE_ERROR, payload: e.message || e })
    yield put({ type: constants.DEBT_NOTICE_LOADING, payload: false })
  }
}

function* registerDebtNoticeRead({ payload }) {
  try {
    yield call(api.registerDebtNoticeRead, payload?.input)
  } catch (e) {
    console.warn('Failed to register debt notice read:', e)
  }
}

export default function* saga() {
  yield takeLatest(constants.GET_DEBT_NOTICE, getDebtNotice)
  yield takeLatest(constants.GET_DEBT_NOTICE_FINANCIAL_RESPONSIBLE, getDebtNoticeFinancialResponsible)
  yield takeLatest(constants.REGISTER_DEBT_NOTICE_READ, registerDebtNoticeRead)
}
